import React, { useState } from 'react';
import { Card, Carousel, Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faStarHalfAlt } from '@fortawesome/free-solid-svg-icons';

const TestimonialsSection = () => {
    const testimonials = [
        {
            stars: 5,
            quote: "MyFit Menu AI opened my eyes. I finally understand what’s actually in the food I buy. It’s like carrying a personal nutritionist in my pocket!",
            name: 'Laura Gonzalez',
            description: 'Personal Trainer',
            initials: 'LG',
        },
        {
            stars: 4.5,
            quote: "Really helpful app. I wish it included more local brands, but overall it’s super accurate and easy to use. Great job!",
            name: 'Carlos Rivera',
            description: 'Concerned Parent',
            initials: 'CR',
        },
        {
            stars: 5,
            quote: "I recommend MyFitMenu AI to all my patients. It breaks down nutrition labels into clear, practical insights anyone can understand.",
            name: 'Dr. Andrea Molina',
            description: 'Clinical Nutritionist',
            initials: 'AM',
        },
        {
            stars: 5,
            quote: "The AI assistant is amazing. It answers every question I have about food and helps me make smarter choices without the guesswork.",
            name: 'Michael Torres',
            description: 'Healthy Lifestyle Blogger',
            initials: 'MT',
        },
        {
            stars: 4,
            quote: "It helps me track calories and avoid ingredients I’m sensitive to. Sometimes responses are a bit slow, but it’s still part of my daily routine.",
            name: 'Valerie Ruiz',
            description: 'Fitness Enthusiast',
            initials: 'VR',
        },
        {
            stars: 5,
            quote: "Super useful for anyone trying to eat clean without the hassle. It even spotted additives I didn’t know were in my food!",
            name: 'Santiago Perez',
            description: 'Mindful Eater',
            initials: 'SP',
        },
    ];

    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    const renderStars = (stars) => {
        const fullStars = Math.floor(stars);
        const halfStar = stars % 1 !== 0;
        const starIcons = [];

        for (let i = 0; i < fullStars; i++) {
            starIcons.push(
                <FontAwesomeIcon
                    key={`full-${i}`}
                    icon={faStar}
                    className="text-warning me-1"
                />
            );
        }

        if (halfStar) {
            starIcons.push(
                <FontAwesomeIcon
                    key="half"
                    icon={faStarHalfAlt}
                    className="text-warning me-1"
                />
            );
        }

        return starIcons;
    };

    // Agrupar testimonios en arrays de 3
    const chunkArray = (arr, size) =>
        arr.reduce((acc, _, i) =>
            i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc, []);

    const groupedTestimonials = chunkArray(testimonials, 3);

    return (
        <Container className="mt-5 mb-5">
            <h2 className="fw-bold display-5 text-center">What Our Users Say</h2>
            <Carousel
                activeIndex={index}
                onSelect={handleSelect}
                indicators
                controls
                interval={null}
            >
                {groupedTestimonials.map((group, idx) => (
                    <Carousel.Item key={idx}>
                        <Row className="gx-4">
                            {group.map((testimonial, i) => (
                                <Col md={4} key={i}>
                                    <Card className="shadow-sm mb-4">
                                        <Card.Body>
                                            <div className="mb-3">{renderStars(testimonial.stars)}</div>
                                            <Card.Text className="mb-3">"{testimonial.quote}"</Card.Text>
                                            <div className="d-flex align-items-center">
                                                <div
                                                    className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                                                    style={{ width: '40px', height: '40px' }}
                                                >
                                                    {testimonial.initials}
                                                </div>
                                                <div className="ms-3">
                                                    <Card.Title className="mb-0">{testimonial.name}</Card.Title>
                                                    <Card.Subtitle className="text-muted">{testimonial.description}</Card.Subtitle>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Carousel.Item>
                ))}
            </Carousel>
        </Container>
    );
};

export default TestimonialsSection;
